import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@shared/components/header/header.component';
import { SearchLineLoaderComponent } from '@shared/components/search-loader/search-line-loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, HeaderComponent, SearchLineLoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {}
